import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DPO_CONSTANT } from './../../utils/constant';
import { CacheService } from './../../services/cache.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CommonService } from 'src/app/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService} from '@ngx-translate/core';   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss'],
})
export class PanelComponent implements OnInit {

  // Define the properties of the component.
  currentURL: string;
  locale: string;
  isSubscriptionAccessible: boolean;
  isConsultationAccessible: boolean;
  DPO_CONSTANT = DPO_CONSTANT;
  languages: Array<any> = [];

  constructor(private router: Router,
    private toastrService: ToastrService,
    private translate:TranslateService,   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
    private cacheService: CacheService,
    private authenticationService: AuthenticationService,
    private commonService: CommonService) { }

  ngOnInit() {
    // Load all the languages for showing in Dropdown
    //CAP-20457: LOT1.1: START - Load languages from JSON + Translation Service changed to translate for JSON
    this.commonService.loadLanguages().subscribe(response => {
      if (response && response['languages'] && response['languages'].length > 0) {
        this.languages = response['languages'];
      }
    }, error => {
      if (error && error.status && error.status === 404 && error.error) {
        this.toastrService.warning(error.error, this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
      } else {
        this.toastrService.error(this.translate.instant('dpo.i18n.message.record.error'), this.translate.instant('dpo.i18n.message.toastr.error'), {closeButton: true,});    //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
      }
    });

    // Set the language of the screen to selected language
    // const selectedLocale = this.cacheService.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE);
    const selectedLocale = localStorage.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE);
    //CAP-20457: LOT1.1: STOP - Load Languages from JSON + Translation Service changed to translate for JSON
    console.log("localStorage language at panel is: " + selectedLocale);
    if (selectedLocale) {
      this.locale = selectedLocale;
    } else {
      this.locale = DPO_CONSTANT.DEFAULT_LOCALE;
    }

    this.currentURL = this.router.url.split('?')[0];
    let userRole = this.authenticationService.getUserRole();
    let applicationName = this.authenticationService.getapplicationName();    // Cap-20753 : Getting the applicationName 
    this.loadPanelByUserRole(userRole, applicationName);    		      // Cap-20753 : Passing extra parameter applicationName 
  }

  // Method to load the access for the screen 
  loadPanelByUserRole(userRole: string , applicationName: string) {   // Cap-20753 : applicationName parameter is added
    this.isSubscriptionAccessible = this.authenticationService.checkSubsciptionAccessible();
    this.isConsultationAccessible = this.authenticationService.checkConsultationAccessible();
  }

  // Method to change the language to the screen.
  changeLocale(locale) {
    //CAP-20457: LOT1.1: START - Translation Service changed to translate for JSON
    this.translate.use(locale);
    localStorage.setItem(DPO_CONSTANT.CACHE_I18N_LOCALE, locale);
    this.authenticationService.event.emit({ languageCode: localStorage.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE)});
    this.cacheService.setItem(DPO_CONSTANT.CACHE_DPO_LANG,'Y');
    //CAP-20457: LOT1.1: STOP - Translation Service changed to translate for JSON
  }

  // Method to logout from the application
  logout() {
    this.authenticationService.unauthenticateUser();
  }

}
